<template>
  <div class="user-card" v-if="user && user.uid">
    <img class="user-card-avatar" :src="getPhoto(user)" @click="goUserCenter" />
    <div class="user-card-nickname" @click="goUserCenter">{{getName(user)}}</div>
    <div class="user-card-title">{{user.title}}</div>
    <div class="user-card-description">{{user.description || user.motto}}</div>
    <div class="user-card-articles-nums">
      累计已发布
      <span>{{user.articles && user.articles.length || 0}}</span> 篇文章
    </div>
    <div style="background: #979797;height: 1px;"></div>
    <div class="user-card-last">最近内容</div>
    <div v-if="user.articles">
      <a
        class="user-card-articles"
        v-for="item in user.articles.slice(0, 3)"
        target="_blank"
        :href="'/p/' +  item._id"
        :key="item._id"
      >{{item.title}}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "user-card",
  props: ["user"],
  created() {
    console.log(this.user);
  },
  methods: {
    goUserCenter() {
      window.open("/usercenter/" + this.user.uid);
    }
  }
};
</script>
<style lang="scss" scoped>
.user-card {
  width: 280px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #eaeaea;
  padding: 22px;
  > .user-card-avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-bottom: 16px;
  }
  > .user-card-nickname {
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(48, 48, 48, 1);
    line-height: 21px;
    margin-bottom: 6px;
  }
  > .user-card-title {
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
    line-height: 17px;
    margin-bottom: 26px;
  }
  > .user-card-description {
    font-size: 14px;
    color: #333333;
  }
  > .user-card-articles-nums {
    font-size: 15px;
    color: rgba(153, 153, 153, 1);
    line-height: 24px;
    text-align: left;
    margin-top: 34px;
    margin-bottom: 16px;
    > span {
      color: #e70012;
    }
  }
  > .user-card-last {
    text-align: left;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
    margin-top: 26px;
    margin-bottom: 12px;
  }
  .user-card-articles {
    display: block;
    text-align: left;
    margin-top: 20px;
    text-decoration: none;
    color: rgba(51, 51, 51, 1);
    &:hover {
      font-weight: bold;
    }
  }
}
</style>


